import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;

const EUR = (n) => new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);

export default function DonationComplete() {
  const [searchParams] = useSearchParams();
  const donationId = searchParams.get("id");

  const [status, setStatus] = useState(null);
  const [donation, setDonation] = useState(null);
  const pollTimer = useRef(null);
  const attempts = useRef(0);

  useEffect(() => {
    if (!donationId) return;

    const check = () => {
      fetch(`${API}/donation/${donationId}/status`)
        .then(r => r.ok ? r.json() : null)
        .then(data => {
          if (!data) return;
          setDonation(data);
          setStatus(data.status);

          // Poll tot max 10× (20s) als nog pending — webhook kan vertraagd zijn
          if (data.status === "pending" && attempts.current < 10) {
            attempts.current++;
            pollTimer.current = setTimeout(check, 2000);
          }
        })
        .catch(() => {});
    };

    check();
    return () => { if (pollTimer.current) clearTimeout(pollTimer.current); };
  }, [donationId]);

  if (!donationId) return (
    <div className="pane">
      <p>Geen betaling gevonden. <Link to="/">Terug naar home</Link></p>
    </div>
  );

  return (
    <div className="pane pane-center">
      {status === "paid" && (
        <>
          <h1>Bedankt voor je donatie!</h1>
          {donation && (
            <p>
              {donation.donorName ? <><strong>{donation.donorName}</strong>, je donatie </> : "Je donatie "}
              van <strong>{EUR(donation.amount)}</strong> is succesvol ontvangen.
            </p>
          )}
          {donation?.athleteId && (
            <Link to={`/athletes/${donation.athleteSlug || donation.athleteId}`} className="btn-primary" style={{ display: "inline-block", marginTop: "1rem" }}>
              Terug naar het profiel
            </Link>
          )}
        </>
      )}

      {(status === "failed" || status === "canceled" || status === "expired") && (
        <>
          <h1>Betaling niet geslaagd</h1>
          <p>De betaling is {status === "canceled" ? "geannuleerd" : status === "expired" ? "verlopen" : "mislukt"}.</p>
          <p>Je kunt het opnieuw proberen via het profiel van de deelnemer.</p>
          {donation?.athleteId && (
            <Link to={`/athletes/${donation.athleteSlug || donation.athleteId}`} className="org-card-link">
              Terug naar het profiel
            </Link>
          )}
        </>
      )}

      {(status === "pending" || status === null) && (
        <>
          <h1>Betaling wordt verwerkt…</h1>
          <p className="note">Even geduld — we controleren de betalingsstatus.</p>
        </>
      )}
    </div>
  );
}
